"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.License = undefined;

var _stringify = require("babel-runtime/core-js/json/stringify");

var _stringify2 = _interopRequireDefault(_stringify);

var _assign = require("babel-runtime/core-js/object/assign");

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = require("react-helmet");

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactRouterRedux = require("react-router-redux");

var _reactRedux = require("react-redux");

var _reduxForm = require("redux-form");

var _UserUtil = require("../../utils/UserUtil");

var _OrderLicenseForm = require("../../components/license/OrderLicenseForm");

var _OrderLicenseForm2 = _interopRequireDefault(_OrderLicenseForm);

var _OrderLicenseConfirmPanel = require("../../components/license/OrderLicenseConfirmPanel");

var _OrderLicenseConfirmPanel2 = _interopRequireDefault(_OrderLicenseConfirmPanel);

var _OrderLicenseSuccessPanel = require("../../components/license/OrderLicenseSuccessPanel");

var _OrderLicenseSuccessPanel2 = _interopRequireDefault(_OrderLicenseSuccessPanel);

var _license = require("../../redux/modules/license");

var _licenseValidator = require("./licenseValidator");

var _licenseValidator2 = _interopRequireDefault(_licenseValidator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var License = exports.License = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(License, _Component);

  function License() {
    (0, _classCallCheck3.default)(this, License);

    var _this = (0, _possibleConstructorReturn3.default)(this, (License.__proto__ || (0, _getPrototypeOf2.default)(License)).call(this));

    _this.state = {
      paytrailSuccessStored: false,
      licenseCreated: false
    };
    return _this;
  }

  (0, _createClass3.default)(License, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var _props = this.props,
          user = _props.user,
          pushRoute = _props.pushRoute,
          license = _props.license,
          pathname = _props.pathname,
          query = _props.query,
          values = _props.values,
          confirmWebPayment = _props.confirmWebPayment,
          orderLicense = _props.orderLicense;

      if (pathname.includes("/success") && query) {
        var orderId = pathname.match(/\/([0-9]+)\/success$/)[1];
        if (!this.state.paytrailSuccessStored) {
          confirmWebPayment(orderId, query);
          user.payment_type = "WEB";
          this.setState({
            paytrailSuccessStored: true
          });
        }
      } else {
        user.payment_type = "INVOICE";
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _props2 = this.props,
          user = _props2.user,
          pushRoute = _props2.pushRoute,
          license = _props2.license,
          pathname = _props2.pathname,
          query = _props2.query,
          values = _props2.values,
          orderLicense = _props2.orderLicense;

      // @@ privateUser

      if (pathname.includes("/success") && query) {
        if (license.confirmWebPaymentSuccess) {
          if (!this.state.licenseCreated) {
            var data = (0, _assign2.default)({}, user, values);
            orderLicense(user.id, data.payment_type, data);
            this.setState({
              licenseCreated: true
            });
          }
        }
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _props3 = this.props,
          user = _props3.user,
          pushRoute = _props3.pushRoute,
          license = _props3.license,
          pathname = _props3.pathname,
          query = _props3.query,
          values = _props3.values,
          orderLicense = _props3.orderLicense;


      if (this.props.user.tempData) {
        var orderLicenseLoading = this.props.license.orderLicenseLoading;
        var _props4 = this.props,
            _orderLicense = _props4.orderLicense,
            _user = _props4.user,
            _values = _props4.values;
        // "API call for Company user..

        if (_values.profile === "COMPANY") {
          var data = (0, _assign2.default)({}, _user, _values);
          data.payment_type = "INVOICE";
          _orderLicense(_user.id, data.payment_type, data);
        }
      }
      if ((0, _UserUtil.isPaidUser)(user)) {
        pushRoute("/");
      }
    }
  }, {
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        { className: "container" },
        _react2.default.createElement(_reactHelmet2.default, { title: "Tilaa maksullinen profiili" }),
        this.defineContent()
      );
    }
  }, {
    key: "registerInfo",
    value: function registerInfo() {
      var user = this.props.user;

      if (!user.tempData) {
        var d = (0, _stringify2.default)(user, null, 4);
        return _react2.default.createElement(
          "div",
          { className: "container" },
          " ",
          d,
          " "
        );
      }

      if (user.tempData) {
        var _d = (0, _stringify2.default)(user.tempData, null, 4);
        return _react2.default.createElement(
          "div",
          { className: "container" },
          " ",
          _d,
          " "
        );
      }
    }
  }, {
    key: "defineContent",
    value: function defineContent() {
      var _props5 = this.props,
          user = _props5.user,
          pushRoute = _props5.pushRoute,
          license = _props5.license,
          pathname = _props5.pathname,
          query = _props5.query,
          values = _props5.values,
          orderLicense = _props5.orderLicense;


      if (license.orderLicenseSuccess) {
        return _react2.default.createElement(_OrderLicenseSuccessPanel2.default, this.props);
      }

      if (license.confirmWebPaymentSuccess) {
        values.business_id = user.business_id || "";
        values.company_name = user.company_name;
        values.company_postal_area = user.postal_area;
        values.company_postal_code = user.postal_code;
        values.order_reference = user.order_reference || "";
        values.profile = user.profile;
        var data = (0, _assign2.default)({}, user, values);

        return _react2.default.createElement(
          "div",
          null,
          _react2.default.createElement(
            "p",
            null,
            " Palataan palveluun "
          )
        );
      }

      if (license.confirmPage) {
        return _react2.default.createElement(_OrderLicenseConfirmPanel2.default, this.props);
      }
      // user is here via registration
      if (user.tempData) {
        return _react2.default.createElement(_OrderLicenseConfirmPanel2.default, this.props);
      }
      return _react2.default.createElement(_OrderLicenseForm2.default, this.props);
    }
  }]);
  return License;
}(_react.Component), _class.propTypes = {
  user: _react.PropTypes.object.isRequired,
  license: _react.PropTypes.object.isRequired,
  pushRoute: _react.PropTypes.func.isRequired,
  company: _react.PropTypes.object,
  confirmWebPayment: _react.PropTypes.func.isRequired,
  placeWebOrder: _react.PropTypes.func.isRequired,
  orderLicense: _react.PropTypes.func.isRequired,
  confirmPage: _react.PropTypes.func.isRequired,
  formPage: _react.PropTypes.func.isRequired,
  fields: _react.PropTypes.object.isRequired,
  values: _react.PropTypes.object.isRequired,
  handleSubmit: _react.PropTypes.func.isRequired,
  query: _react.PropTypes.object,
  pathname: _react.PropTypes.string.isRequired
}, _temp);
exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    license: state.license,
    company: state.company.company,
    pathname: state.routing.locationBeforeTransitions.pathname,
    query: state.routing.locationBeforeTransitions.query
  };
}, {
  pushRoute: _reactRouterRedux.push,
  confirmWebPayment: _license.confirmWebPayment,
  orderLicense: _license.orderLicense,
  placeWebOrder: _license.placeWebOrder,
  confirmPage: _license.confirmPage,
  formPage: _license.formPage
})((0, _reduxForm.reduxForm)({
  form: "orderLicense",
  fields: ["address", "postal_code", "postal_area", "profile", "business_id", "company_name", "company_address", "company_postal_code", "company_postal_area", "order_reference"],
  validate: _licenseValidator2.default
})(License));


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/License/License.js
 ** module id = 1216
 ** module chunks = 0
 **/